import StoreApi from '@api/store'
import { GRANT_PASS } from '@utils/constants'
import {
  STORE_INIT_SERVICE,
  STORE_SET_ORDER_PRICE,
  STORE_RESET_ORDER_PRICE,
  STORE_ORDER_PRODUCT_ID,
  STORE_CID_LIST,
  STORE_UNSUBMIT_STATUS
} from '../mutationTypes'

const state = {
  services: [],
  orderPrice: {
    vouchers: {}
  },
  orderProductId: "",
  cid_list: [],
  isUnSubmit: false
}

const getters = {
  // 可用优惠券列表
  vouchers (store) {
    return store.orderPrice.vouchers
  },
  // 优惠券是否为空
  isNotEmptyOfVoucher (store) {
    const { agency_vouchers, client_vouchers } = store.orderPrice.vouchers
    const isNotEmpty = data => data && data.length > 0
    return isNotEmpty(agency_vouchers) || isNotEmpty(client_vouchers)
  },
  // 所选产品订单价格
  finalPrice (store) {
    const { amount, discount, original_amount: originalAmount, discount_amount: discountAmount } = store.orderPrice
    return { amount, discount, originalAmount, discountAmount }
  },
  // 计价的产品及服务
  orderProduct(store) {
    return store.orderPrice.product_list
  },
  // 是否需要升级和续约提示
  isReducedVersionHints (store) {
    return store.orderPrice.reduced_version_hints
  }
}

const actions = {
  //获取产品服务列表
  async fetchProductService({ commit }, contract_id) {
    const services = await StoreApi.fetchProductService({
      order_product_id: contract_id
    });
    commit(STORE_INIT_SERVICE, services);
  },
  // 订单价格
  async fetchOrderPrice({ commit }, params) {
    if (params.params.length < 1) {
      return commit(STORE_RESET_ORDER_PRICE)
    }
    const data = await StoreApi.fetchOrderPrice({
      ...params,
      client_id: window.__xm_wx.clientId
    })
    commit(STORE_SET_ORDER_PRICE, data)
  },
  async saveOrder(state, params) {
    return StoreApi.saveOrder(params)
  },
  async fetchGoogleCid({ commit }) {
    const cid_list = await StoreApi.fetchGoogleCidList({ grant_status: GRANT_PASS });
    commit(STORE_CID_LIST, cid_list);
  }
}

const mutations = {
  [STORE_INIT_SERVICE](state, data) {
    const result = data.reduce((result, item) => {
      result[item.product_id] = item
      return result
    }, {})
    state.services = Object.freeze(result)
  },
  [STORE_SET_ORDER_PRICE](state, data) {
    state.orderPrice = Object.freeze(data)
  },
  [STORE_RESET_ORDER_PRICE] (state) {
    state.orderPrice = {
      amount: 0,
      discount: 0,
      originalAmount: 0,
      vouchers: {}
    }
  },
  [STORE_ORDER_PRODUCT_ID](state, data) {
    state.orderProductId = data;
  },
  [STORE_CID_LIST](state, data){
    state.cid_list = data;
  },
  [STORE_UNSUBMIT_STATUS](state, data){
    state.isUnSubmit = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}